import { ReviewDetails } from '../ReviewDetails';

import { ReviewDetailsContext } from '../context/ReviewDetailsContext';

export const GuestReviewDetails = () => {
  return (
    <ReviewDetailsContext.Provider
      value={{
        mode: 'guest',
      }}
    >
      <ReviewDetails />
    </ReviewDetailsContext.Provider>
  );
};
